import { render, staticRenderFns } from "./HeaderCards.vue?vue&type=template&id=c23679fe&scoped=true&lang=pug"
import script from "./HeaderCards.vue?vue&type=script&lang=js"
export * from "./HeaderCards.vue?vue&type=script&lang=js"
import style0 from "./HeaderCards.vue?vue&type=style&index=0&id=c23679fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23679fe",
  null
  
)

export default component.exports